/* eslint react/destructuring-assignment: 0 */

import React from 'react'
import PropTypes from 'prop-types'
import { Route, matchPath } from 'react-router-dom'
import router from './router'


class LayoutSwitch extends React.Component {

  static contextTypes = {
    router: PropTypes.shape({
      route: PropTypes.object.isRequired,
    }).isRequired,
  }

  match = null
  nodesToRender = []

  matchRoute = (child) => {
    const { router: { route } } = this.context
    const { path, from, exact, strict, sensitive } = child.props

    const location = this.props.location || route.location

    return matchPath(location.pathname, { path: path || from, exact, strict, sensitive }, route.match)
  }

  /*

    match /zoo

    <Route path="/foo" />
    <Redirect from="/bar0" to="/bar1" />

    <InsideLayout>
      <Route path="/bar1" />
      <Route path="/bar2" />
    </InsideLayout>

    <HasAuth>
      <InsideLayout>
        <Route path="/zoo" />
      </InsideLayout>
    </HasAuth>

   */
  matchRoutes = (children) => {
    React.Children.forEach(children, (child) => {
      if (!this.match && React.isValidElement(child)) {
        if (child.props.children) {
          // if node is Layout then add it to nodesToRender
          this.nodesToRender.push(child)
          // and iterate again
          this.matchRoutes(child.props.children)

          // if in nested routes no match then remove added Layout (move up by tree)
          if (!this.match) {
            this.nodesToRender.pop()
          }
        }
        else {
          this.match = this.matchRoute(child)

          // if pathname match route path then add Route to nodesToRender
          if (this.match) {
            this.nodesToRender.push(child)
          }
        }
      }
    })

    // TODO move this to separate container
    if (this.match) {
      router.dispatch(this.match)
    }
  }

  renderNodes() {
    const { router: { route } } = this.context

    const location = this.props.location || route.location

    return this.nodesToRender.reverse().reduce((result, node) => {
      // render route
      if (!result) {
        // TODO try to replace Route with Component, ask @pivanov
        // return React.createElement(node.props.component, { location })
        return React.cloneElement(node, { location, computedMatch: this.match })
      }

      // render layout
      return React.cloneElement(node, { location }, result)
    }, null)
  }

  render() {
    const { router: { route } } = this.context
    const { children } = this.props

    const location = this.props.location || route.location

    this.match = null
    this.nodesToRender = []

    this.matchRoutes(children)

    if (!this.match) {
      return null
    }

    return React.createElement(Route, { location, computedMatch: this.match }, this.renderNodes())
  }
}


export default LayoutSwitch
